import * as Sentry from '@sentry/react';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// to automatically detect browser language, install the
// `i18next-browser-languagedetector` package
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    lng: 'en',
    // Enable saveMissing so that missingKeyHandler and missingKey event fire
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key, fallbackValue) => {
      // Report missing translation key to Sentry
      Sentry.captureMessage('Missing translation key', {
        level: 'warning',
        tags: {
          type: 'i18n',
          namespace: ns,
        },
        extra: {
          key,
          fallbackValue,
          namespace: ns,
        },
      });
    },
    react: {
      transSupportBasicHtmlNodes: true,
    },
    returnNull: false,
  });
